import type { WorldView } from "../render/world-view.js";
import { AnchoredOverlay } from "./anchored-overlay.js";

export interface XpFloaterSpawn {
  amount: number;
  anchorId: string;
}

export class XpFloater {
  private readonly overlay: AnchoredOverlay<XpFloaterSpawn>;

  constructor(layer: HTMLElement, worldView: WorldView) {
    this.overlay = new AnchoredOverlay({
      layer,
      worldView,
      durationMs: 1400,
      fadeBeforeMs: 500,
      yOffset: -44,
      riseProgressPx: 36,
      createNode: ({ amount }) => {
        if (amount === 0) return null;
        const positive = amount > 0;
        const node = document.createElement("div");
        node.className = `xp-float ${positive ? "xp-gain" : "xp-loss"}`;
        node.textContent = positive ? `+${amount} XP` : `${amount} XP`;
        return node;
      },
    });
  }

  spawn(spawn: XpFloaterSpawn, now = performance.now()): void {
    this.overlay.spawn(spawn.anchorId, spawn, now);
  }

  destroy(): void {
    this.overlay.destroy();
  }
}
